module.exports = __webpack_public_path__ + "static/media/lobster-mobiles.bf56b5cf.jpg";